import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Icon from '@rio-cloud/rio-uikit/Icon';
import type React from 'react';
import { FormattedMessage } from 'react-intl';

export const SuccessPage = ({ displayTextId, children }: { displayTextId: string; children?: React.ReactNode }) => {
    const showCloseButton = window.top === window.self;
    const closeWindow = () => window.close();
    return (
        <ApplicationLayout>
            <ApplicationLayout.Body>
                <div className='container-fluid padding-0'>
                    <div
                        className={
                            'alert alert-success position-relative overflow-hidden rounded-large ' +
                            'display-flex flex-column justify-content-center width-100pct max-width-600 ' +
                            'min-height-150 margin-auto padding-30 text-size-14'
                        }
                        role='status'
                        aria-live='polite'
                        aria-atomic='true'
                    >
                        <div
                            className={
                                'position-absolute top-25 right-25 opacity-10 ' +
                                'pointer-events-none text-color-success scale-200'
                            }
                            aria-hidden='true'
                        >
                            <Icon iconName='icon-check-badge' size='h1' />
                        </div>
                        <div className='position-relative padding-right-75'>
                            <h3
                                className={
                                    'text-size-20 text-bold line-height-125rel text-wrap-balance ' +
                                    'margin-top-0 margin-bottom-10'
                                }
                            >
                                <FormattedMessage id={displayTextId} />
                            </h3>
                            <div className='text-size-14 text-wrap-balance'>{children}</div>
                            {showCloseButton && (
                                <div className='margin-top-20'>
                                    <button type={'button'} className={'btn btn-primary'} onClick={closeWindow}>
                                        <FormattedMessage id={'intl-msg:contactForm.close'} />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
};
